<template>
    <!-- Sidebar Start -->
    <div class="sidebar pe-4 pb-3">
            <nav class="navbar bg-light navbar-light">
                <a href="/" class="navbar-brand mx-4 mb-3">
                    <h3 class="" style="color:#00C853;"><i class="fa fa-hashtag me-2"></i>ZGH</h3>
                </a>
                <div class="d-flex align-items-center ms-4 mb-4">
                    <div class="position-relative">
                        <i class="rounded-circle fa fa-user fa-2x"></i>
                        <div class="bg-success rounded-circle border border-2 border-white position-absolute end-0 bottom-0 p-1"></div>
                    </div>
                    <div class="ms-3">
                        <h6 class="mb-0">{{ profil }}</h6>
                        <span>{{ role }}</span>
                    </div>
                </div>
                <div class="navbar-nav w-100">
                    <a href="/" class="nav-item nav-link" :class="{'active': $route.path === '/dashboard' }"><i class="fa fa-tachometer-alt me-2"></i>Dashboard</a>
                    
                     <div class="nav-item dropdown">
                        <a href="#" class="nav-link dropdown-toggle" data-bs-toggle="dropdown" :class="{'active': $route.path.includes('/patient') }" :aria-expanded="$route.path.includes('/patient') ? 'true' : 'false'"><i class="fa fa-wheelchair me-2"></i>Patients</a>
                        <div class="dropdown-menu bg-transparent border-0 menu-decalee" :class="{'show': $route.path.includes('/patient') }">
                            <a href="/patient-register" class="dropdown-item" :class="{'active': $route.path === '/patient-register' }">Ajouter</a>
                            <a href="/patient-all" class="dropdown-item" :class="{'active': $route.path === '/patient-all' }">Lister</a>
                        </div>
                    </div>
                    <div class="nav-item dropdown">
                        <a href="#" class="nav-link dropdown-toggle" data-bs-toggle="dropdown" :class="{ 'active': $route.path.includes('/consultation-preliminaire') || $route.path.includes('/rendez-vous') || $route.path.includes('/dossier-declasser') }" :aria-expanded="($route.path.includes('/consultation-preliminaire') || $route.path.includes('/rendez-vous') || $route.path.includes('/dossier-declasser')) ? 'true' : 'false'"
><i class="fa fas fa-address-book me-2"></i>Consultations</a>
                        <div class="dropdown-menu bg-transparent border-0 menu-decalee" :class="{ 'show': $route.path.includes('/consultation-preliminaire') || $route.path.includes('/rendez-vous') || $route.path.includes('/dossier-declasser') }">
                            <!-- <a href="/dossier-declasser" class="dropdown-item">Tous</a> -->
                                <a href="/consultation-preliminaire" class="dropdown-item" :class="{'active': $route.path === '/consultation-preliminaire' }">Préliminaire</a>
                                <a href="/dossier-declasser" class="dropdown-item" :class="{'active': $route.path === '/dossier-declasser' }">Générale</a>
                                <a href="/rendez-vous" class="dropdown-item" :class="{'active': $route.path === '/rendez-vous' }">Rendez-vous</a>
                        </div>
                    </div>
                    <div class="nav-item dropdown" v-if="roleId == 3">
                        <a href="#" class="nav-link dropdown-toggle" data-bs-toggle="dropdown"><i class="fa fas fa-address-book me-2"></i>Urgences</a>
                        <div class="dropdown-menu bg-transparent border-0 menu-decalee">
                            <!-- <a href="/dossier-declasser" class="dropdown-item">Tous</a> -->
                                <a href="#" class="dropdown-item">Lister</a>
                                <a href="#" class="dropdown-item">Ajouter</a>
                        </div>
                    </div>
                    <div class="nav-item dropdown" v-if="roleId == 3">
                        <a href="#" class="nav-link dropdown-toggle" data-bs-toggle="dropdown"><i class="fa fas fa-address-book me-2"></i>Hospitalisation</a>
                        <div class="dropdown-menu bg-transparent border-0 menu-decalee">
                            <!-- <a href="/dossier-declasser" class="dropdown-item">Tous</a> -->
                                <a href="#" class="dropdown-item">Lister</a>
                                <a href="#" class="dropdown-item">Ajouter</a>
                        </div>
                    </div>
                    <div class="nav-item dropdown" v-if="roleId == 3">
                        <a href="#" class="nav-link dropdown-toggle" data-bs-toggle="dropdown"><i class="fa fas fa-address-book me-2"></i>Laboratoire</a>
                        <div class="dropdown-menu bg-transparent border-0 menu-decalee">
                            <!-- <a href="/dossier-declasser" class="dropdown-item">Tous</a> -->
                                <a href="#" class="dropdown-item">Lister</a>
                                <a href="#" class="dropdown-item">Ajouter</a>
                        </div>
                    </div>
                    <div class="nav-item dropdown">
                        <a href="#" class="nav-link dropdown-toggle" data-bs-toggle="dropdown"><i class="fa fas fa-address-book me-2"></i>Logistique</a>
                        <div class="dropdown-menu bg-transparent border-0 menu-decalee">
                            <!-- <a href="/dossier-declasser" class="dropdown-item">Tous</a> -->
                                <a href="#" class="dropdown-item">Lister</a>
                                <a href="#" class="dropdown-item">Ajouter</a>
                        </div>
                    </div>
                    <div class="nav-item dropdown">
                        <a href="#" class="nav-link dropdown-toggle" data-bs-toggle="dropdown" :class="{ 'active': $route.path.includes('/assurance-all') || $route.path.includes('/service-all') || $route.path.includes('/factures') || $route.path.includes('/transactions') }" :aria-expanded="($route.path.includes('/transactions') || $route.path.includes('/factures') || $route.path.includes('/assurance-all') || $route.path.includes('/service-all')) ? 'true' : 'false'"><i class="fa fa-dollar me-2"></i>Comptabilité</a>
                        <div class="dropdown-menu bg-transparent border-0 menu-decalee" :class="{ 'show': $route.path.includes('/assurance-all') || $route.path.includes('/service-all') || $route.path.includes('/factures') || $route.path.includes('/transactions') }">
                            <a href="/assurance-all" class="dropdown-item" :class="{'active': $route.path === '/assurance-all' }">Assurance</a>
                            <a href="/service-all" class="dropdown-item" :class="{'active': $route.path === '/service-all' }">Service</a>
                            <a href="/factures" class="dropdown-item" :class="{'active': $route.path === '/factures' }">Factures</a>
                            <a href="/transactions" class="dropdown-item" :class="{'active': $route.path === '/transactions' }">Transactions</a>
                        </div>
                    </div>
                    <div class="nav-item dropdown">
                                <a href="#" class="nav-link dropdown-toggle" data-bs-toggle="dropdown" :class="{ 'active': $route.path.includes('/specialite-all') || $route.path.includes('/user-all') || $route.path.includes('/user-register') || $route.path.startsWith('/group')}" :aria-expanded="($route.path.includes('/specialite-all') || $route.path.includes('/user-all') || $route.path.includes('/user-register') || $route.path.startsWith('/group')) ? 'true' : 'false'">
                                    <i class="fa fa-cog me-2"></i>Paramètres
                                </a>
                        <div class="dropdown-menu bg-transparent border-0 menu-decalee" :class="{ 'show': $route.path.includes('/specialite-all') || $route.path.includes('/user-all') || $route.path.includes('/user-register') || $route.path.startsWith('/group')}">
                            
                             <!-- Section Groupes -->
                              <a href="/specialite-all" class="dropdown-item" :class="{'active': $route.path === '/specialite-all' }">Spécialités</a>
                             <h6 class="dropdown-header">Utilisateurs</h6>
                            <a href="/user-register" class="dropdown-item sub-item" :class="{'active': $route.path === '/user-register' }">Ajouter</a>
                            <a href="/user-all" class="dropdown-item sub-item" :class="{'active': $route.path.includes('/user-all') }">Lister</a>
                            <div class="dropdown-divider"></div>
                            <h6 class="dropdown-header">Groupes</h6>
                            <a href="/group-register" class="dropdown-item sub-item" :class="{'active': $route.path.includes('/group-register') }">Ajouter</a>
                            <a href="/group-all" class="dropdown-item sub-item" :class="{'active': $route.path.includes('/group-all') }">Lister</a>
                        </div>
                    </div>
                    <div class="nav-item dropdown">
                        <a href="#" class="nav-link dropdown-toggle" data-bs-toggle="dropdown"><i class="fa fa-wheelchair me-2"></i>Supports</a>
                        <div class="dropdown-menu bg-transparent border-0 menu-decalee">
                            <a href="#" class="dropdown-item">Technique</a>
                            <a href="#" class="dropdown-item">FAQ</a>
                        </div>
                    </div>

                    
                </div>
            </nav>
        </div>
        <!-- Sidebar End -->
</template>

<script>
    export default {
        name:"LeftSideBar",
        data(){
            return{
                profil:(this.$store.getters.currentUser).prenom??'',
                role:(this.$store.getters.currentUser).role??'',
                roleId:(this.$store.getters.currentUser).code_role??'',

            }
        },
        methods:{
            isDropdownOpen(paths) {
                return paths.some(path => this.$route.path.startsWith(path));
            }
        }
    }
</script>

<style scoped>
.menu-decalee {
    margin-left: 2.5rem; /* ou padding-left selon l'effet désiré */
}

</style>